import { defineStore } from 'pinia'

import { PageType } from '@shared/config'

export const useCommonStore = defineStore('common', () => {
  const loading = ref(false)
  const pageType = ref(PageType.Math)
  const modalTutorApplication = ref(false)
  const modalTutorApplicationSuccess = ref(false)

  const isMathLanding = computed(() => pageType.value === PageType.Math)
  const isElaLanding = computed(() => pageType.value === PageType.Ela)
  const isDemoLanding = computed(() => pageType.value === PageType.Demo)

  const setLoading = (payload: boolean): void => {
    loading.value = payload
  }
  const setPageType = (payload: PageType): void => {
    pageType.value = payload
  }
  const setModalTutorApplication = (payload: boolean): void => {
    modalTutorApplication.value = payload
  }
  const setModalTutorApplicationSuccess = (payload: boolean): void => {
    modalTutorApplicationSuccess.value = payload
  }

  const reset = (): void => {
    loading.value = false
    pageType.value = PageType.Math
    modalTutorApplication.value = false
    modalTutorApplicationSuccess.value = false
  }

  return {
    loading,
    pageType,
    modalTutorApplication,
    modalTutorApplicationSuccess,
    isMathLanding,
    isElaLanding,
    isDemoLanding,
    setLoading,
    setPageType,
    setModalTutorApplication,
    setModalTutorApplicationSuccess,
    reset,
  }
})
